import React from 'react';
import { FormattedMessage, IntlShape } from 'react-intl';

import { ErrorOverlayBottom } from '../../error/error-overlay-bottom/component';

import styles from './styles.module.css';

export const getOverlayBottom = (
    intl: IntlShape,
    vsid?: string,
    sessionId?: string,
    errorCode?: string
) => {
    const helpfulText = intl.formatMessage({
        id: 'features.player.f7803f2c7d2f0e625f95b9202fca01fd',
        defaultMessage: 'This information will be useful for support',
        description: 'Hint about support data (player error screen)',
    });

    const errorCodeText = intl.formatMessage(
        {
            id: 'features.player.ebe5b5b3d5c53c80cc13b36c5fe63b86',
            defaultMessage: 'Error code: {errorCode}',
            description: 'Error info on player error screen',
        },
        { errorCode }
    );

    if (vsid !== undefined) {
        return (
            <ErrorOverlayBottom>
                <div>{helpfulText}</div>
                <div className={styles.session_container}>
                    <FormattedMessage
                        id="features.player.50434a46176a9aefa2c78a0be66271f0"
                        defaultMessage="<span>Session VSID:</span><span>{vsid}</span>"
                        description="VSID session text on player error screen"
                        values={{ vsid, span: (chunks) => <span>{chunks}</span> }}
                    />
                </div>
                <div>{errorCodeText}</div>
            </ErrorOverlayBottom>
        );
    }

    if (sessionId !== undefined) {
        return (
            <ErrorOverlayBottom>
                <div>{helpfulText}</div>
                <div className={styles.session_container}>
                    <FormattedMessage
                        id="features.player.6d45bcc7db347ba514abc42a8ebbf9a5"
                        defaultMessage="<span>Session ID:</span><span>{sessionId}</span>"
                        description="Session ID text on player error screen"
                        values={{ sessionId, span: (chunks) => <span>{chunks}</span> }}
                    />
                </div>
                <div>{errorCodeText}</div>
            </ErrorOverlayBottom>
        );
    }

    return null;
};
